export const processCalendarEntryQueryFormStyles = {
  fieldset: {
    border: 0,
    m: 0,
    p: 0,
  },
};
